// export const enterFullScreen = async () => {
//     try {
//       if (document.documentElement.requestFullscreen) {
//         await document.documentElement.requestFullscreen();
//       } else if (document.documentElement.mozRequestFullScreen) { // Firefox
//         await document.documentElement.mozRequestFullScreen();
//       } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari, and Opera
//         await document.documentElement.webkitRequestfullscreen();
//       } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
//         await document.documentElement.msRequestFullscreen();
//       }
//     } catch (error) {
//       console.error('Error attempting to enable full-screen mode:', error);
//       throw error; // Re-throw the error for handling in the component
//     }
//   };

export const enterFullScreen = async () => {
  try {
      // Request media permissions first
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

      // Ensure the function is triggered by user interaction
      if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) { // Firefox
          document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari, Opera
          document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
          document.documentElement.msRequestFullscreen();
      } else {
          console.warn("Full-screen mode is not supported on this browser.");
      }
  } catch (error) {
      console.error('Error requesting permissions or entering full-screen:', error);
  }
};